import { ParamsType } from './index'

const denormalizer = ({ pageSize, pageNo, queryLiveTime, liveTypes, roomMode }: ParamsType) => {
  return {
    queryLiveTime: queryLiveTime || new Date(),
    pageSize,
    pageNo,
    liveTypes,
    roomMode,
  }
}

export default denormalizer
